<style src="./Sidebar.scss" lang="scss"></style>

<template lang="pug">
  .sidebar
    .sidebar__logo
      Logo
    .sidebar__usermenu
      UserMenu
    .sidebar__nav
      Nav
</template>

<script>
import Logo from "@/components/Logo/Logo";
import Nav from "@/components/Nav/Nav";
import UserMenu from "@/components/UserMenu/UserMenu";

export default {
  components: {
    Logo,
    Nav,
    UserMenu
  }
};
</script>
